import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { HomeawayLinkValidation } from 'uplisting-frontend/validations';

export default class HomeawayLinkRepositoryService extends BaseRepositoryService<
  ModelRegistry['homeaway-link']
> {
  recordName = 'homeaway-link';
  implementMethods = ['buildChangeset', 'peekAll'];

  validation = HomeawayLinkValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/homeaway-link': HomeawayLinkRepositoryService;
  }
}
